import React, {useRef} from 'react';

import Marks from "./Marks";


export default function MarksPanelControl({ marks, marksProperties = {}, onMarksChanged, onMarkDelete, onMarkActiveChange, onConvertShape, canEdit = false, onBringToBack, onBringToFront }) {
    const onMarkChange = (markId, union, visible = null, attributes = null) => {
        let newMarks = {...marks};
        newMarks[markId].geoJSON.properties.union = union;

        if (visible !== null) {
            newMarks[markId].geoJSON.properties.visible = visible;
        }

        if (attributes !== null) {
            Object.keys(attributes).forEach((key) => {
                newMarks[markId].geoJSON.properties[key] = attributes[key];
            });
        }

        onMarksChanged(newMarks);
    }


    return marks ? Object.keys(marks).map((markId, index) => (
        <Marks
            key={markId}
            sortOrder={index}
            id={markId}
            data={marks[markId]}
            properties={marksProperties[markId] || {}}
            active={marks[markId].active}
            visible={!(marks[markId].geoJSON && marks[markId].geoJSON.properties && marks[markId].geoJSON.properties.visible === false)}
            canEdit={canEdit}

            onActiveChange={onMarkActiveChange}
            onConvertShape={onConvertShape}
            onSelfDelete={onMarkDelete}
            onMarkChange={onMarkChange}
            onBringToBack={onBringToBack}
            onBringToFront={onBringToFront}
        />
    )) : null;
}